import {RouteRecordRaw} from 'vue-router'
import ListaUtenti from "@/views/Admin/ListaUtenti.vue";
import DettaglioUtente from "@/views/Admin/DettaglioUtente.vue";
import HomeCrm from "@/views/HomeCrm.vue";
import HomePermessi from "@/views/Admin/HomePermessi.vue";
import PermessiMenu from "@/components/PermessiMenu.vue";
import ListaRuoli from "@/views/Admin/ListaRuoli.vue";
import DettaglioRuolo from "@/views/Admin/DettaglioRuolo.vue";
import ListaPermessi from "@/views/Admin/ListaPermessi.vue";
import ListaAziendeGruppo from "@/views/Admin/ListaAziendeGruppo.vue";
import DettaglioAziendaGruppo from "@/views/Admin/DettaglioAziendaGruppo.vue";
import BusinessUnits from "@/views/Admin/BusinessUnits.vue";
import BusinessUnitsDetail from "@/views/Admin/BusinessUnitsDetail.vue";
import VociSpesaBusinessUnitsIva from "@/views/Admin/VociSpesaBusinessUnitsIva.vue";
import DettaglioVociSpesaBusinessUnitsIva from "@/views/Admin/DettaglioVociSpesaBusinessUnitsIva.vue";
import LoginNinja from "@/views/Admin/LoginNinja.vue";
import AttivitaTimesheet from "@/views/Admin/AttivitaTimesheet.vue";
import DettaglioAttivitaTimesheet from "@/views/Admin/DettaglioAttivitaTimesheet.vue";
import BilanciPrevisionali from "@/views/Admin/BilanciPrevisionali.vue";
import DettaglioBilancioPrevisionali from "@/views/Admin/DettaglioBilancioPrevisionali.vue";

const userRoutes: Array<RouteRecordRaw> = [
    {
        path: '/admin/',
        meta: {'app': 'per'},
        components: {
            default: HomeCrm,
            nav: PermessiMenu,
        },
        children: [
            {
                path: '',
                component: HomePermessi,
                name: 'HomePermessi'
            },
            {
                path: 'users/',
                component: ListaUtenti,
                name: 'ListaUtenti'
            },
            {
                path: 'aziendegruppo/',
                component: ListaAziendeGruppo,
                name: 'ListaAziendeGruppo'
            },
            {
                path: 'aziendegruppo/:id/',
                component: DettaglioAziendaGruppo,
                name: 'DettaglioAziendaGruppo',
                props: true
            },
            {
                path: 'users/:id/',
                component: DettaglioUtente,
                name: 'DettaglioUtente',
                props: true
            },
            {
                path: 'roles',
                component: ListaRuoli,
                name: 'ListaRuoli'
            },
            {
                path: 'roles/:id/',
                component: DettaglioRuolo,
                name: 'DettaglioRuolo',
                props: true
            },
            {
                path: 'permissions',
                component: ListaPermessi,
                name: 'ListaPermessi',
                props: true
            },
            {
                path: 'businessunits',
                component: BusinessUnits,
                name: 'BusinessUnits',
                props: true
            },
            {
                path: 'businessunits/:id/',
                component: BusinessUnitsDetail,
                name: 'DettaglioBusinessUnit',
                props: true
            },
            {
                path: 'vs_bu_iva/',
                component: VociSpesaBusinessUnitsIva,
                name: 'VociSpesaBusinessUnitsIva',
                props: true
            },
            {
                path: 'vs_bu_iva/create',
                component: DettaglioVociSpesaBusinessUnitsIva,
                name: 'CreaVociSpesaBusinessUnitsIva',
                props: true
            },
            {
                path: 'vs_bu_iva/:id/',
                component: DettaglioVociSpesaBusinessUnitsIva,
                name: 'DettaglioVociSpesaBusinessUnitsIva',
                props: true
            },
            {
                path: 'login_ninja',
                component: LoginNinja,
                name: 'LoginNinja',
                props: true
            },
            {
                path: 'attivita_timesheet',
                component: AttivitaTimesheet,
                name: 'AttivitaTimesheet',
                props: true
            },
            {
                path: 'attivita_timesheet/create',
                component: DettaglioAttivitaTimesheet,
                name: 'CreaAttivitaTimesheet',
                props: true
            },
            {
                path: 'attivita_timesheet/:id/',
                component: DettaglioAttivitaTimesheet,
                name: 'DettaglioAttivitaTimesheet',
                props: true
            },
            {
                path: 'bilanci_previsionali/',
                component: BilanciPrevisionali,
                name: 'BilanciPrevisionali',
                props: true
            },
            {
                path: 'bilanci_previsionali/create/',
                component: DettaglioBilancioPrevisionali,
                name: 'CreaBilancioPrevisionale',
                props: true
            },
            {
                path: 'bilanci_previsionali/:id/',
                component: DettaglioBilancioPrevisionali,
                name: 'DettaglioBilancioPrevisionale',
                props: true
            },
        ],
    },
]

export default userRoutes
